module.exports = __webpack_public_path__ + "img/patrick-bruel-2024.72c9f3d1.jpg";